import get from 'lodash/get';
import {
  getItemOrDefaultToValue,
  getPhoneNumber,
  nestedDisplay,
} from '../../details';

export const transform = (data, globalDepartmentList = []) => {
  const selectedDepartments = globalDepartmentList.filter(f =>
    getItemOrDefaultToValue(data, 'departmentIds', []).includes(f.id),
  );
  let contactPerson = '-';
  const employees =
    data.employees != null
      ? data.employees.map(employee => {
          const generalData = get(employee, 'general', {});
          const personDetails = `${generalData.firstName} ${
            generalData.lastName
          } - ${generalData.email} - ${getPhoneNumber(
            generalData.phoneNumber,
          )}`;
          if (data.contact && data.contact.general.id === generalData.id) {
            contactPerson = personDetails;
          }
          return {
            display: personDetails,
            id: generalData.id,
            name: `${generalData.firstName} ${generalData.lastName}`,
            raw: employee,
          };
        })
      : []; // to allow mapping to continue

  let displayContact = {};
  const contact = get(data, 'contact');

  if (contact) {
    displayContact = {
      ...contact.general,
      label: `${contact.general.firstName} ${contact.general.lastName}`,
      value: {
        ...contact,
        general: {
          ...contact.general,
          businessClientId: data.id,
          businessClientName: data.name,
        },
      },
    };
  }

  const transformedOutput = {
    generalInfo: {
      businessClientId: {
        type: 'text',
        label: 'Business Client ID',
        value: getItemOrDefaultToValue(data, 'businessClientId', '-'),
      },
      companyName: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'name', '-'),
      },
      departments: {
        type: 'array',
        label: 'Departments',
        value: nestedDisplay(selectedDepartments),
      },
    },
    detailedInfo: {
      address: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'address', '-'),
      },
      contactPerson: { type: 'text', value: contactPerson },
      customers: { type: 'array', value: employees }, //businessClient details have customers and not employees as these customers are seen on the customer panel in managerial view
      description: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'description', '-'),
      },
    },
    others: {
      id: { value: getItemOrDefaultToValue(data, 'id') },
      // clients: { value: Array.isArray(employees) ? employees : [] },
      contact: { value: displayContact },
      image: { value: getItemOrDefaultToValue(data, 'imageUrl') },
      archived: {
        value: getItemOrDefaultToValue(data, 'archived', false),
      },
    },
  };
  return transformedOutput;
};
